export default __webpack_public_path__ + "static/media/AutomationText.693dbd30.svg";